import {type UseFleetScoreOverTimeOutput} from './use-fleet-score-over-time-output'
import {use} from 'react'
import {FleetScoreOverTimeContext} from './fleet-score-over-time-context'
import {warn} from '../../../../../helpers/logging'
import * as ActionCreators from './state/action-creators'
import {type VesselTag} from '../../../../../api/vessels/vessel-tags'

export function useFleetScoreOverTime(): UseFleetScoreOverTimeOutput {
    const {state, dispatch} = use(FleetScoreOverTimeContext)
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (state == undefined || dispatch == undefined) {
        throw new Error('useFleetScoreOverTime must be used within a FleetScoreOverTimeContext')
    }

    function fetchFilter(assignedTag: VesselTag | undefined): void {
        if (!dispatch) {
            warn('dispatch is not defined')
            return
        }
        ActionCreators.fetchFleetScoreOverTimeFilter(dispatch, assignedTag)
    }

    function setShowFilter(show = false): void {
        if (!dispatch) {
            warn('dispatch is not defined')
            return
        }
        dispatch(ActionCreators.showFilter(show))
    }

    function setSearchVesselTagTerm(value: VesselTag | undefined): void {
        if (!dispatch) {
            warn('dispatch is not defined')
            return
        }
        ActionCreators.setSearchVesselTagTerm(value, dispatch, state.fleetScoreOverTimeFilter)
    }

    return {
        loadingFilterState: state.loadingFilterState,
        fetchFilter,
        showFilter: state.showFilter,
        setShowFilter,
        searchedVesselTagTerm: state.fleetScoreOverTimeFilter.searchedVesselTagTerm,
        setSearchVesselTagTerm,
    }
}
